export default "__VITE_ASSET__db0a68ac__"